// @noflow
import { forwardRef, Fragment } from 'react';
import MuiButton from '@material-ui/core/Button';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { Colors, Buttons } from 'styles';

const Variants = {
  ROUNDED: 'rounded',
  ROUNDED_CONTRAST: 'roundedContrast',
  ROUNDED_CONTRAST_LIGHT: 'roundedContrastLight',
  ROUNDED_BLUE: 'roundedBlue',
  ROUNDED_RED: 'roundedRed',
  ROUNDED_YELLOW: 'roundedYellow',
  ROUNDED_GRAY: 'roundedGray',
  GRAY: 'gray',
};

const WrapperLink = styled(Link)`
  display: contents;
  all: unset;
`;

const Button = forwardRef((props, ref) => {
  const isLink = props.to != null;

  const Wrapper = isLink ? WrapperLink : Fragment;
  const linkProps = isLink ? { to: props.to, ref } : {};
  const wrapperProps = isLink ? {} : { ref };

  return (
    <Wrapper {...linkProps}>
      <MuiButton
        {...props}
        {...wrapperProps}
        size={['xsmall', 'small'].includes(props.size) ? 'small' : undefined}
        variant="outlined"
        css={`
          color: ${props.variant === Variants.ROUNDED ? 'inherit' : Colors.white};
          text-decoration: none;
          height: ${props.size === 'small' ? 3.5 : props.size === 'xsmall' ? 2.5 : 4}rem;
          ${props.variant === Variants.ROUNDED
            ? css`
                ${css(Buttons.baseButton)};
                border: 1px solid currentColor;
              `
            : undefined}
          ${props.variant === Variants.ROUNDED_CONTRAST
            ? css`
                ${css(Buttons.baseButton)};
                border: 1px solid ${Colors.gray1};
              `
            : undefined}
            ${props.variant === Variants.ROUNDED_CONTRAST_LIGHT
            ? css`
                ${css(Buttons.baseButton)};
                border: 1px solid ${Colors.white};
              `
            : undefined}
          ${props.variant === Variants.ROUNDED_BLUE ? css(Buttons.blueButton) : undefined};
          ${props.variant === Variants.ROUNDED_RED ? css(Buttons.redButton) : undefined};
          ${props.variant === Variants.ROUNDED_YELLOW ? css(Buttons.yellowButton) : undefined};
          ${[Variants.ROUNDED_GRAY, Variants.GRAY].includes(props.variant)
            ? css(Buttons.grayButton)
            : undefined};

          ${props.disabled ? css(Buttons.grayButton) : undefined};

          ${props.variant?.startsWith('rounded')
            ? css`
                padding: 0rem ${props.size === 'small' ? 2 : props.size === 'xsmall' ? 1 : 4}rem;
                border-radius: 2rem;
              `
            : undefined}
          padding: .6rem 3.6rem;
        `}
      />
    </Wrapper>
  );
});
Button.displayName = 'Button';

export { Variants };
export default Button;
